(() => {
  const script =
    document.currentScript || document.querySelector('script[src*="leo-age-check"]');
  if (!script) return;

  const config = {
    types: (script.dataset.types || '')
      .split(',')
      .map((value) => value.trim().toLowerCase())
      .filter(Boolean),
    keywords: (script.dataset.keywords || '')
      .split(',')
      .map((value) => value.trim().toLowerCase())
      .filter(Boolean),
    label: script.dataset.label || '',
    hint: script.dataset.hint || '',
  };

  if (config.types.length === 0 && config.keywords.length === 0) return;

  const storageKey = 'leo-age-confirmed';
  const marker = 'leoAgeCheck';

  let restricted = false;

  const isConfirmed = () => {
    try {
      return sessionStorage.getItem(storageKey) === 'true';
    } catch (error) {
      return false;
    }
  };

  const setConfirmed = (value) => {
    try {
      sessionStorage.setItem(storageKey, value ? 'true' : 'false');
    } catch (error) {
      return;
    }
  };

  const matches = (item) => {
    const type = (item.product_type || '').toLowerCase().trim();
    const handle = (item.handle || '').toLowerCase();

    if (config.types.includes(type)) return true;
    return config.keywords.some((keyword) => handle.includes(keyword));
  };

  const fetchCart = async () => {
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) return null;
      return await response.json();
    } catch (error) {
      return null;
    }
  };

  const buildNotice = () => {
    const wrapper = document.createElement('div');
    wrapper.className = 'leo-age-check';
    wrapper.dataset[marker] = 'true';

    const row = document.createElement('label');
    row.className = 'leo-age-check__row';

    const input = document.createElement('input');
    input.type = 'checkbox';
    input.className = 'leo-age-check__input';
    input.checked = isConfirmed();

    const text = document.createElement('span');
    text.className = 'leo-age-check__label';
    text.innerHTML = config.label;

    row.append(input, text);
    wrapper.append(row);

    if (config.hint) {
      const hint = document.createElement('p');
      hint.className = 'leo-age-check__hint';
      hint.innerHTML = config.hint;
      wrapper.append(hint);
    }

    input.addEventListener('change', () => {
      setConfirmed(input.checked);
      sync();
    });

    return wrapper;
  };

  const lockButtons = (locked) => {
    document.querySelectorAll('.cart__checkout-button').forEach((button) => {
      if (locked) {
        button.setAttribute('disabled', 'disabled');
        button.dataset[marker] = 'locked';
      } else if (button.dataset[marker] === 'locked') {
        button.removeAttribute('disabled');
        delete button.dataset[marker];
      }
    });

    document.querySelectorAll('.additional-checkout-buttons').forEach((block) => {
      block.style.pointerEvents = locked ? 'none' : '';
      block.style.opacity = locked ? '0.4' : '';
      block.setAttribute('aria-hidden', locked ? 'true' : 'false');
    });
  };

  const sync = () => {
    const confirmed = isConfirmed();

    document.querySelectorAll('.leo-age-check').forEach((node) => {
      node.hidden = !restricted;
      node.classList.toggle('is-missing', restricted && !confirmed);
      const input = node.querySelector('.leo-age-check__input');
      if (input) input.checked = confirmed;
    });

    lockButtons(restricted && !confirmed);
  };

  const mount = () => {
    document.querySelectorAll('.cart__ctas').forEach((ctas) => {
      if (ctas.previousElementSibling?.classList.contains('leo-age-check')) return;
      ctas.parentNode.insertBefore(buildNotice(), ctas);
    });

    sync();
  };

  const refresh = async () => {
    const cart = await fetchCart();
    if (!cart) return;

    const wasRestricted = restricted;
    restricted = Array.isArray(cart.items) && cart.items.some(matches);

    if (!restricted && wasRestricted) setConfirmed(false);

    mount();
  };

  document.addEventListener('cart:update', refresh);
  document.addEventListener('cart:add', refresh);

  const observer = new MutationObserver(() => {
    if (document.querySelector('.cart__ctas:not(:has(+ .leo-age-check))')) mount();
    else sync();
  });

  observer.observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh, { once: true });
  } else {
    refresh();
  }
})();